import { render, staticRenderFns } from "./TaskUpdateChecklist.vue?vue&type=template&id=5feee2b6&scoped=true"
import script from "./TaskUpdateChecklist.vue?vue&type=script&lang=js"
export * from "./TaskUpdateChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feee2b6",
  null
  
)

export default component.exports